import React from 'react';
import { rest } from '../../data/rest/api';
import { startGlobalLoading, stopGlobalLoading } from '../../layout/globalLoading';
import { toast } from 'react-toastify';

const HologicWebDeploy = (props) => {
	const [version, setVersion] = React.useState('');
	const [cmdOutput, setCmdOutput] = React.useState('');

	const deploy = async () => {
		if (version.length < 2) {
			alert('Version is required.');
			return;
		}
		try {
			startGlobalLoading();
			setCmdOutput('');
			const result = await rest('POST', '/api/deployHologicWeb', { version });
			setCmdOutput(result);
			toast.success('HologicWeb deployed successfully!');
		} catch (err) {
			toast.error(err.message);
		} finally {
			stopGlobalLoading();
		}
	};

	return (
		<div className="container">
			<div className="jumbotron jumbotron-fluid">
				<div className="">
					<h1 className="display-4">Deploy HologicWeb</h1>
					<p className="lead">
						Updates <b>hologicweb</b> image and sets <b>HOLOGIC_WEBSITE_VERSION</b> in the manage
						deployment — without touching the Ingress.
					</p>
				</div>
			</div>

			<div className="w-50">
				<div className="form-group mt-2">
					<label>Version (Docker tag)</label>
					<input
						onChange={(e) => setVersion(e.target.value)}
						value={version}
						type="text"
						className="form-control"
						placeholder="e.g. 1.2.3"
					/>
				</div>
			</div>

			<button onClick={deploy} className="btn btn-primary mt-3 mb-3">
				DEPLOY
			</button>
			&ensp;
			<button
				onClick={() => props.history.goBack()}
				className="btn btn-outline-primary mt-3 mb-3"
			>
				CANCEL
			</button>

			{cmdOutput ? (
				<textarea readOnly={true} style={{ width: '100%', height: '30vh' }} value={cmdOutput} className="mt-3" />
			) : null}
		</div>
	);
};

export default HologicWebDeploy;
